import Header from '../header/header';
import Button from '../../../../ui/button/button';
import { BUTTON_VARIANTS } from '../../../../constants/button-variants';
import { world } from '../../../../languages';

const NotAvailablePage = () => {
    return (
        <div>
            <Header />
            <div className='tsc-h4 text-center mt-5'>
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                We're sorry, but our payment methods are not supported in your location.
            </div>
            <div className='d-flex justify-content-center mt-3'>
                <Button variant={BUTTON_VARIANTS.YELLOW} onClick={() => window.locationReload(`/${world}`)}>
                    Go to homepage
                </Button>
            </div>
        </div>
    );
};

export default NotAvailablePage;
